export default {"src":"/_next/static/media/product-v2.8fef29c0.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};